window.app_models.hotel = {
    id:null,
    name:null,
    email:null,
    info:null,
    pets:null,
    kitchen:null,
    certifi_required:null,
    card_id:null,
    virtual_card_id:null,
    check_in_time: null,
    check_out_time: null,
    card:window.app_models.option,
    address:window.app_models.address
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/hotel.js